import React from "react";

import styles from "../../../../styles/add-product.module.scss";

import { Button } from "../../../components/Button";
import { Hairline } from "../../../components/Hairline";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";
import { Radio } from "../../../components/Radio";
import { Message } from "../../../components/Message";
import { Select } from "../../../components/Select";
import { Icon } from "../../../components/core/Icon";

export default class SetStagesStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addStep: false,
      answerType: null,
      productAnswers: [],
      productSteps: [],
      ordination: false,
      has_steps: props.product.has_steps || false,
      categories: props.categories || {},
      category: props.category || {},
      product: props.product || {},
      onChange: props.onChange || {},
      onChangeHasSteps: props.onChangeHasSteps || {},
    };
  }

  render() {
    const {
      addStep,
      answerType,
      productAnswers,
      productSteps,
      ordination,
    } = this.state;

    const { setAddStep } = this.props;

    return (
      <>
        {!addStep && (
          <>
            <Label>Este produto possui etapas?</Label>
            <Radio
              id="without-step"
              family="has-steps"
              value={false}
              checked={this.state.has_steps}
              className="mb-15"
              onChange={() => {
                this.setState({ has_steps: false });
                this.state.onChangeHasSteps(false)
              }}
            >
              Não
            </Radio>
            <Radio
              id="with-step"
              family="has-steps"
              value={true}
              checked={this.state.has_steps}
              onChange={() => {
                this.setState({ has_steps: true });
                this.state.onChangeHasSteps(true)
              }}
            >
              Sim
            </Radio>
          </>
        )}

        {this.state.has_steps && (
          <>
            <Hairline className="mt-20 mb-20" />

            <div className="d-flex align-center justify-between relative">
              <Label>Configure as etapas deste produto</Label>
              <span className={styles.numberSteps}>{productSteps.length}</span>
            </div>

            <div className="d-flex">
              {!ordination && (
                <>
                  {productSteps.length > 0 && (
                    <Button
                      design="default-icon-2"
                      onClick={() => this.setState({ ordination: true })}
                      className="mr-15"
                    >
                      <Icon name="sort-size-up-alt" size="lg" />
                    </Button>
                  )}

                  <Button
                    design="default-2"
                    className="w-100"
                    onClick={() => {
                      this.setState({
                        has_steps: true,
                        addStep: true,
                        productSteps: [...productSteps, {}],
                      });
                      setAddStep(true);
                    }}
                  >
                    Adicionar etapa
                  </Button>
                </>
              )}

              {ordination && (
                <Button
                  design="default-2"
                  className="w-100"
                  onClick={() => this.setState({ ordination: false })}
                >
                  Salvar ordenação
                </Button>
              )}
            </div>
          </>
        )}

        {addStep && (
          <>
            {
              productSteps.map((step, index) => {
                return (
                  <div key={index} className="mt-10">
                    <Label>Pergunta</Label>
                    <Input
                      design="two"
                      placeholder="Ex. Deseja por molho?"
                      onChange={(e) => {
                        let p = productSteps;
                        p[index].question = e.target.value;
                        this.setState({ productSteps: p })
                      }}
                    />

                    <Hairline className="mt-20 mb-20" />

                    <Label>Respostas</Label>

                    {!step.answerType && (
                      <div className="d-flex">
                        <Button
                          design="default-2"
                          className="w-100"
                          onClick={() => {
                            let p = productSteps;
                            p[index].answerType = "withText";
                            p[index].productAnswers = [{}];
                            this.setState({ productSteps: p })
                          }}
                        >
                          Respostas em texto
                        </Button>
                        <Button
                          design="default-2"
                          className="w-100 ml-15"
                          onClick={() => {
                            let p = productSteps;
                            p[index].answerType = "withProducts";
                            p[index].productAnswers = [{}];
                            this.setState({ productSteps: p })
                          }}
                        >
                          Respostas com produtos
                        </Button>
                      </div>
                    )}

                    {step.answerType === "withText" && (
                      <>
                        {
                          step.productAnswers.map((_, answerIndex) => {
                            return (
                              <div key={answerIndex} className="d-flex mt-20">
                                <Input
                                  design="two"
                                  className="w-100"
                                  onChange={(e) => {
                                    let p = productSteps;
                                    p[index].productAnswers[answerIndex].answer = e.target.value;
                                    this.setState({ productSteps: p })
                                  }}
                                />
                                <Input
                                  label="Valor"
                                  design="two"
                                  className="w-50 ml-15"
                                  onChange={(e) => {
                                    let p = productSteps;
                                    p[index].productAnswers[answerIndex].value = e.target.value;
                                    this.setState({ productSteps: p })
                                  }}
                                />
                                <Button
                                  design="default-icon-2"
                                  onClick={() => {
                                    let p = productSteps;
                                    p[index].productAnswers = p[index].productAnswers.filter((_, i) => i !== answerIndex)
                                    this.setState({ productSteps: p })
                                  }}
                                  className="ml-15"
                                >
                                  <Icon name="times" size="xl" />
                                </Button>
                              </div>
                            )
                          })
                        }
                        <Button
                          design="default-2"
                          className="w-100 mt-20"
                          onClick={() => {
                            let p = productSteps;
                            p[index].answerType = "withText";
                            p[index].productAnswers = [...p[index].productAnswers, {}];
                            this.setState({ productSteps: p })
                          }}
                        >
                          Adicionar respostas em texto
                        </Button>
                      </>
                    )}

                    {step.answerType === "withProducts" && (
                      <>
                        {
                          step.productAnswers.map((answer, answerIndex) => {
                            return (
                              <div key={answerIndex} className="mt-20">
                                <Message>
                                  Este método simplesmente copia o nome dos produtos para as
                                  respostas, desta forma não há vinculo nenhum entre os dois
                                  elementos. Logo, caso hajam alterações no produto copiado,
                                  será necessário replicar essas alterações aqui.
                                </Message>

                                <div className="d-flex mt-30">
                                  <Select
                                    value={
                                      productSteps[index].productAnswers[answerIndex].categoryId
                                    }
                                    design="two"
                                    className="flex-1"
                                    label="Selecione o produto"
                                    options={
                                      [
                                        { value: null, label: null },
                                        ...this.state.categories.map(
                                          e => ({ value: e.id, label: e.name })
                                        )
                                      ]
                                    }
                                    onChange={(e) => {
                                      let p = productSteps;
                                      productSteps[index].productAnswers[answerIndex].categoryId = parseInt(e.target.value)
                                      p[index].productAnswers[answerIndex].products = e.target.value
                                        ? this.state.categories.find(
                                          item => item.id === parseInt(e.target.value)
                                        ).items
                                        : null;
                                      this.setState({ productSteps: p })
                                    }}
                                  />
                                  <Button
                                    design="default-icon-2"
                                    onClick={() => {
                                      let p = productSteps;
                                      p[index].productAnswers = p[index].productAnswers.filter((_, i) => i !== answerIndex)
                                      this.setState({ productSteps: p })
                                    }}
                                    className="ml-15"
                                  >
                                    <Icon name="times" size="xl" />
                                  </Button>
                                </div>
                                {
                                  productSteps[index].productAnswers[answerIndex].products && (
                                    <>
                                      {
                                        productSteps[index].productAnswers[answerIndex].products.map((pInfo, pIndex) => {
                                          return (
                                            <>
                                              <div key={`pchilds-${pIndex}`} className="d-flex mt-20">
                                                <Input
                                                  design="two"
                                                  className="w-45"
                                                  value={pInfo.name}
                                                  disabled
                                                />
                                                <Input
                                                  label="Valor"
                                                  design="two"
                                                  className="w-45 ml-10"
                                                  onChange={(e) => {
                                                    let p = productSteps;
                                                    p[index].productAnswers[answerIndex].products[pIndex].base_price = e.target.value
                                                    this.setState({ productSteps: p })
                                                  }}
                                                />
                                              </div>
                                            </>
                                          )
                                        })
                                      }
                                    </>
                                  )
                                }
                              </div>
                            )
                          })
                        }
                        <Button
                          design="default-2"
                          className="w-100 mt-20"
                          onClick={() => {
                            let p = productSteps;
                            p[index].answerType = "withProducts";
                            p[index].productAnswers = [...p[index].productAnswers, {}];
                            this.setState({ productSteps: p })
                          }}
                        >
                          Adicionar respostas com produto
                        </Button>
                      </>
                    )}

                    <Hairline className="mt-20 mb-20" />

                    <Label>
                      Quais são as quantidades mínimas e máximas desta etapa?
                    </Label>
                    <div class="mb-55">
                      <Input
                        id="min"
                        name="min"
                        design="two"
                        className="mt-10 w-45"
                        floatLabel="Min. a selecionar"
                        onChange={(e) => {
                          let p = productSteps;
                          p[index].min = e.target.value;
                          this.setState({ productSteps: p })
                        }}
                      />
                      <Input
                        id="max"
                        name="max"
                        design="two"
                        className="mt-10 w-45"
                        floatLabel="Max. a selecionar"
                        onChange={(e) => {
                          let p = productSteps;
                          p[index].max = e.target.value;
                          this.setState({ productSteps: p })
                        }}
                      />
                    </div>
                  </div>
                )
              })
            }
          </>
        )}

        {addStep && (
          <div className={styles.footerColumn}>
            <Button
              design="primary"
              className="w-100"
              onClick={() => {
                this.state.onChange(productSteps)
                this.setState({
                  has_steps: true,
                  addStep: false,
                  answerType: null,
                  productSteps: productSteps,
                });
                setAddStep(false);
                this.state.onChangeHasSteps(true)
              }}
            >
              Criar etapa
            </Button>
            <Button
              design="default-2"
              onClick={() => {
                this.setState({
                  has_steps: false,
                  addStep: false,
                  answerType: null
                });
                setAddStep(false);
              }}
              className="mt-20 w-100"
            >
              Cancelar
            </Button>
          </div>
        )}
      </>
    );
  }
}
